function toggleFaq(btn){var item=btn.closest(".faq-item"),isOpen=item.classList.contains("open");document.querySelectorAll(".faq-item").forEach(function(i){i.classList.remove("open");var b=i.querySelector(".faq-q");b&&b.setAttribute("aria-expanded","false")}),isOpen||(item.classList.add("open"),btn.setAttribute("aria-expanded","true"))}var VARIANT_ID=50110038474945,plans={monthly:{price:"$119",note:"Billed $119/mo \xB7 cancel anytime",save:null,cta:"Join Monthly, $119/mo \u2192",nav:"Join the Community \u2192",selling_plan:4019486913},quarterly:{price:"$107",note:"Billed $428/quarter \xB7 cancel anytime",save:"Save 10%, $142/yr vs monthly",cta:"Join Quarterly, $428/quarter \u2192",nav:"Join from $107/mo \u2192",selling_plan:4034986177},annual:{price:"$95",note:"Billed $1,143/yr \xB7 cancel anytime",save:"Save 20%, $285/yr vs monthly",cta:"Join Annual, $1,143/yr \u2192",nav:"Join from $95/mo \u2192",selling_plan:4035018945}},currentPlan="monthly";function submitCartForm(sellingPlanId){var form=document.createElement("form");form.method="POST",form.action="/cart/add",form.style.display="none";function addField(name,value){var input=document.createElement("input");input.type="hidden",input.name=name,input.value=value,form.appendChild(input)}addField("id",VARIANT_ID),addField("quantity",1),sellingPlanId&&addField("selling_plan",sellingPlanId),addField("return_to","/checkout"),document.body.appendChild(form),form.submit()}function addToCart(planKey){var plan=plans[planKey],btn=document.getElementById("join-cta"),orig=btn.textContent;btn.textContent="Processing\u2026",btn.style.opacity="0.7",btn.style.pointerEvents="none",fetch("/cart/clear.js",{method:"POST",headers:{"Content-Type":"application/json"}}).then(function(){return fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:[{id:VARIANT_ID,quantity:1,selling_plan:plan.selling_plan}]})})}).then(function(res){return res.ok?res.json():(submitCartForm(plan.selling_plan),null)}).then(function(data){if(data!==null)if(data.items||data.id)window.location.href="/checkout";else throw new Error(data.description||"Could not add to cart")}).catch(function(err){console.error("Cart error:",err),submitCartForm(plan.selling_plan)})}function setPlan(plan){currentPlan=plan;var p=plans[plan];document.getElementById("price-amount").textContent=p.price,document.getElementById("billed-note").textContent=p.note;var badge=document.getElementById("save-badge");p.save?(badge.textContent="\u2713 "+p.save,badge.classList.remove("hidden")):badge.classList.add("hidden"),document.getElementById("join-cta").textContent=p.cta;var navCta=document.getElementById("nav-cta");navCta&&(navCta.textContent=p.nav),["monthly","quarterly","annual"].forEach(function(k){document.getElementById("cmp-"+k).classList.toggle("current",k===plan)}),document.querySelectorAll(".billing-pill").forEach(function(b){b.classList.toggle("active",b.dataset.plan===plan)}),slidePill(plan)}function slidePill(plan){var pills=document.querySelectorAll(".billing-pill"),slider=document.getElementById("pillSlider"),container=document.getElementById("billingPills"),idx=["monthly","quarterly","annual"].indexOf(plan);if(!(idx<0||!pills[idx])){var pRect=pills[idx].getBoundingClientRect(),cRect=container.getBoundingClientRect();slider.style.left=pRect.left-cRect.left+"px",slider.style.width=pRect.width+"px"}}window.addEventListener("load",function(){slidePill("monthly")}),window.addEventListener("resize",function(){slidePill(currentPlan)}),(function(){document.querySelectorAll("[data-hv-video]").forEach(function(wrap){var video=wrap.querySelector("video"),btn=wrap.querySelector(".hv-play");!video||!btn||(btn.addEventListener("click",function(){var p=video.play();p&&typeof p.catch=="function"&&p.catch(function(){})}),video.addEventListener("play",function(){wrap.classList.add("is-playing")}),video.addEventListener("pause",function(){!video.ended&&video.currentTime===0&&wrap.classList.remove("is-playing")}),video.addEventListener("ended",function(){wrap.classList.remove("is-playing")}))})})();
/* Testimonials auto-scrolling chain carousel */
(function(){
  var root=document.querySelector('[data-tchain]');
  if(!root) return;
  var track=root.querySelector('.tchain-track');
  var slides=[].slice.call(root.querySelectorAll('.tslide'));
  var dotsWrap=root.querySelector('.tchain-dots');
  var n=slides.length, i=0, timer=null, DELAY=6000;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var dots=[];
  for(var d=0; d<n; d++){(function(idx){
    var b=document.createElement('button');
    b.className='tchain-dot'; b.type='button'; b.setAttribute('role','tab');
    b.setAttribute('aria-label','Show testimonial '+(idx+1));
    b.addEventListener('click',function(){go(idx);restart();});
    dotsWrap.appendChild(b); dots.push(b);
  })(d);}
  function render(){
    track.style.transform='translateX('+(-i*100)+'%)';
    for(var k=0;k<n;k++){
      dots[k].classList.toggle('active',k===i);
      dots[k].setAttribute('aria-selected',k===i?'true':'false');
      slides[k].setAttribute('aria-hidden',k===i?'false':'true');
    }
  }
  function go(x){ i=(x%n+n)%n; render(); }
  function next(){ go(i+1); }
  function prev(){ go(i-1); }
  function start(){ if(reduce) return; stop(); timer=setInterval(next,DELAY); }
  function stop(){ if(timer){clearInterval(timer); timer=null;} }
  function restart(){ stop(); start(); }
  root.querySelector('.tchain-next').addEventListener('click',function(){next();restart();});
  root.querySelector('.tchain-prev').addEventListener('click',function(){prev();restart();});
  root.addEventListener('mouseenter',stop);
  root.addEventListener('mouseleave',start);
  root.addEventListener('focusin',stop);
  root.addEventListener('focusout',start);
  document.addEventListener('visibilitychange',function(){ document.hidden?stop():start(); });
  render(); start();
})();
/* Hero heading: SplitText-style staggered character reveal (vanilla, no deps) */
(function(){
  var h1=document.querySelector('.sr-hero h1');
  if(!h1) return;
  if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  h1.setAttribute('aria-label',h1.textContent.trim());
  var chars=[];
  function split(el){
    [].slice.call(el.childNodes).forEach(function(node){
      if(node.nodeType===3){
        var frag=document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach(function(part){
          if(part==='') return;
          if(/^\s+$/.test(part)){ frag.appendChild(document.createTextNode(part)); return; }
          var w=document.createElement('span'); w.className='rb-word';
          part.split('').forEach(function(ch){
            var s=document.createElement('span');
            s.className='rb-char'; s.setAttribute('aria-hidden','true'); s.textContent=ch;
            w.appendChild(s); chars.push(s);
          });
          frag.appendChild(w);
        });
        el.replaceChild(frag,node);
      } else if(node.nodeType===1){ split(node); }
    });
  }
  split(h1);
  function play(){
    requestAnimationFrame(function(){
      chars.forEach(function(c,idx){ c.style.transitionDelay=(idx*0.05)+'s'; c.classList.add('rb-in'); });
    });
  }
  if(document.fonts&&document.fonts.ready){ document.fonts.ready.then(play); } else { play(); }
})();
//# sourceMappingURL=/cdn/shop/t/14/assets/spectrum-community.js.map?v=63473216706137145861779231026

/* === redesign additions (orbit / stat counter / video accordion) === */
/* Audience radial orbital timeline (vanilla port of the React Bits component) */
(function(){
  var orbit=document.querySelector('[data-orbit]'); if(!orbit) return;
  var stage=orbit.querySelector('.orbit-stage');
  var nodes=[].slice.call(orbit.querySelectorAll('.orbit-node'));
  var card=orbit.querySelector('.orbit-card');
  var total=nodes.length, angle=0, auto=true, active=null, raf=0, last=0;
  var radius=128;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function place(){
    for(var i=0;i<total;i++){
      var a=(((i/total)*360+angle)%360)*Math.PI/180;
      var x=radius*Math.cos(a), y=radius*Math.sin(a);
      var n=nodes[i];
      n.style.transform='translate(-50%,-50%) translate('+x.toFixed(1)+'px,'+y.toFixed(1)+'px)';
      n.style.zIndex=(n===active?200:Math.round(100+50*Math.cos(a)));
      n.style.opacity=(n===active)?1:Math.max(.45,Math.min(1,.45+.55*((1+Math.sin(a))/2))).toFixed(2);
    }
  }
  function tick(t){
    raf=requestAnimationFrame(tick);
    if(!auto) return;
    if(!last) last=t;
    angle=(angle+(t-last)*0.006)%360; last=t;
    place();
  }
  function open(n){
    active=n; auto=false; orbit.classList.add('has-active');
    nodes.forEach(function(x){ x.classList.toggle('is-open', x===n); });
    card.querySelector('h4').innerHTML=n.getAttribute('data-title');
    card.querySelector('p').textContent=n.getAttribute('data-desc');
    card.classList.add('show');
    place();
  }
  function close(){
    active=null; auto=!reduce; last=0; orbit.classList.remove('has-active');
    nodes.forEach(function(x){ x.classList.remove('is-open'); });
    card.classList.remove('show');
  }
  var pinned=false;
  nodes.forEach(function(n){
    n.addEventListener('mouseenter',function(){ if(!pinned) open(n); });
    n.addEventListener('mouseleave',function(){ if(!pinned) close(); });
    n.addEventListener('focus',function(){ if(!pinned) open(n); });
    n.addEventListener('blur',function(){ if(!pinned) close(); });
    n.addEventListener('click',function(e){ e.stopPropagation(); if(pinned&&active===n){ pinned=false; close(); } else { pinned=true; open(n); } });
  });
  stage.addEventListener('click',function(e){ if(e.target===stage||e.target===card||e.target.closest('.orbit-center')){ pinned=false; close(); } });
  place();
  if(!reduce){ raf=requestAnimationFrame(tick); }
})();

/* Trust stats count-up — animates each .ts-num when scrolled into view.
   Preserves any prefix/suffix (e.g. "30+", "100%", "2x"). */
(function(){
  var nums = [].slice.call(document.querySelectorAll('.ts-num'));
  if(!nums.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  nums.forEach(function(el){
    var raw = el.textContent.trim();
    var m = raw.match(/([^\d]*)(\d[\d,]*)(.*)/);
    if(!m){ el.dataset.done='1'; return; }
    el.dataset.pre = m[1];
    el.dataset.target = m[2].replace(/,/g,'');
    el.dataset.suf = m[3];
    if(!reduce) el.textContent = m[1] + '0' + m[3];
  });
  function ease(t){ return 1 - Math.pow(1-t, 3); }
  function run(el){
    if(el.dataset.done) return;
    el.dataset.done='1';
    var target = parseInt(el.dataset.target,10), pre = el.dataset.pre, suf = el.dataset.suf;
    if(reduce){ el.textContent = pre + target + suf; return; }
    var dur = 1400, start = null;
    function step(ts){
      if(start===null) start=ts;
      var p = Math.min((ts-start)/dur, 1);
      var val = Math.round(ease(p)*target);
      el.textContent = pre + val + suf;
      if(p<1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  if(!('IntersectionObserver' in window)){ nums.forEach(run); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ run(e.target); io.unobserve(e.target); } });
  }, {threshold:0.4});
  nums.forEach(function(el){ io.observe(el); });
})();

/* "In this video" expandable checklist — accordion (one open at a time) */
(function(){
  var box = document.querySelector('[data-hv-learn]');
  if(!box) return;
  var qs = [].slice.call(box.querySelectorAll('.hv-learn-q'));
  qs.forEach(function(q){
    q.addEventListener('click', function(){
      var open = q.getAttribute('aria-expanded') === 'true';
      qs.forEach(function(o){ o.setAttribute('aria-expanded','false'); });
      q.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  });
})();
